import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import styles from "@/styles/TabMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";

function Menu(_ref) {
  var element = _ref.element,
      text = _ref.text,
      link = _ref.link;
  return /*#__PURE__*/_jsx(ActiveLink, _objectSpread(_objectSpread({}, link), {}, {
    children: /*#__PURE__*/_jsx("a", {
      className: styles.menu,
      children: element || text
    })
  }));
}

export default function TabMenu(_ref2) {
  var menus = _ref2.menus;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx(ScrollMenu, {
      children: menus.map(function (menu, i) {
        return /*#__PURE__*/_jsx(Menu, _objectSpread({}, menu), "menu=".concat(i));
      })
    })
  });
}